import { gspApi } from 'shared/api/gsp';
import { FALLBACK_LNG as DEFAULT_LOCALE } from 'shared/constants/translation';
import { useAppSelector } from 'shared/hooks/store';

export const useDefaultLocale = () => {
  const selectedLocale = useAppSelector(
    state => gspApi.endpoints.getApiUserSettings.select()(state)?.data?.locale,
  );

  const defaultSchoolLocale = useAppSelector(
    state =>
      gspApi.endpoints.getApiSchoolSettings.select()(state)?.data?.localization
        ?.defaultLocale,
  );

  return selectedLocale || defaultSchoolLocale || DEFAULT_LOCALE;
};
